import { Suspense, lazy } from 'react';

import { RuntimeEnvironmentOptions, getEnvFromHostname } from '@growtherapy/analytics';

const BrandingDevToolsContent = lazy(() => import('./BrandingDevToolsContent'));

export function BrandingDevTools() {
  const isProduction = getEnvFromHostname({ hostname: location.hostname }) === RuntimeEnvironmentOptions.production;

  if (isProduction) return null;

  return (
    <Suspense fallback={null}>
      <BrandingDevToolsContent />
    </Suspense>
  );
}
